/* FlexyMinds events page (sections/fm-events-list.liquid).
   Loads live + upcoming events from the FlexyMinds app API in the browser (the store plan has no
   server-side fetch), keeps the last copy in localStorage, refetches once an hour while the tab is
   visible and re-renders the "Live now / Starts in …" labels every minute.
   Event shape is the one of tools/flow/fm-events-run-code.js, so a metafield copy could feed the same render. */
(function () {
  if (window.fmEventsLoaded) return;
  window.fmEventsLoaded = true;

  var TTL = 60 * 60000; // cached copy is used without fetching this long
  var REFRESH = 60 * 60000;
  var TICK = 60000;

  /* ---------- data ---------- */

  function absUrl(origin, u) {
    if (!u || /^data:/.test(u)) return ''; // inline covers are test data, too heavy to keep
    if (/^https?:\/\//.test(u)) return u;
    return origin + (u.charAt(0) === '/' ? '' : '/') + u;
  }

  function points(r) {
    return r && typeof r.points === 'number' ? r.points : null;
  }

  function normalize(origin, e) {
    var r = e.rewards || {};
    return {
      id: e.id,
      title: e.title || '',
      text: e.shortDescription || e.tagline || e.description || '',
      type: e.eventType || '',
      game: e.gameTitle || '',
      more_games: (e.allGameIDs || e.targetGameIDs || []).filter(function (id, i, all) {
        return id && id !== e.gameId && all.indexOf(id) === i;
      }).length,
      start: (Date.parse(e.startTime) || 0) / 1000,
      end: (Date.parse(e.endTime) || 0) / 1000,
      color: e.themeColor || '',
      cover: absUrl(origin, e.coverImageUrl),
      registered: e.registeredCount || 0,
      rewards: {
        first: points(r.firstPlace),
        second: points(r.secondPlace),
        third: points(r.thirdPlace),
        participation: points(r.participation || r.participationSticker) // tournaments send participationSticker
      },
      divisions: (e.divisions || []).map(function (d) {
        return { name: d.name || '', min_age: d.minAge, max_age: d.maxAge, text: d.description || '' };
      })
    };
  }

  function Feed(url) {
    this.url = url;
    this.key = 'fm-events:v4:' + url;
    this.origin = url.replace(/^(https?:\/\/[^\/]+).*$/, '$1');
    this.offset = 0; // server clock - local clock, ms
    this.data = null;
    this.inflight = null;
  }

  Feed.prototype.now = function () {
    return (Date.now() + this.offset) / 1000;
  };

  Feed.prototype.cached = function () {
    try {
      var c = JSON.parse(localStorage.getItem(this.key));
      if (c && c.events && c.fetchedAt) {
        this.offset = c.offset || 0;
        this.data = c;
      }
    } catch (err) {}
    return this.data;
  };

  Feed.prototype.fetch = function () {
    var self = this;
    if (self.inflight) return self.inflight;
    self.inflight = fetch(self.url, { headers: { Accept: 'application/json' }, credentials: 'omit' })
      .then(function (r) {
        if (!r.ok) throw new Error('fm-events: HTTP ' + r.status);
        return r.json();
      })
      .then(function (json) {
        if (!json || !Array.isArray(json.events)) throw new Error('fm-events: no events');
        var server = Date.parse(json.serverTime);
        if (server) self.offset = server - Date.now();
        self.data = {
          events: json.events
            .filter(function (e) { return !e.status || e.status === 'published'; })
            .map(function (e) { return normalize(self.origin, e); })
            .filter(function (e) { return e.id && e.start && e.end; }),
          fetchedAt: Date.now(),
          offset: self.offset
        };
        try { localStorage.setItem(self.key, JSON.stringify(self.data)); } catch (err) {}
        return self.data;
      });
    self.inflight.then(done, done);
    function done() { self.inflight = null; }
    return self.inflight;
  };

  Feed.prototype.fresh = function () {
    return this.data && Date.now() - this.data.fetchedAt < TTL;
  };

  /* ---------- formatting ---------- */

  function fill(str, vars) {
    return String(str || '').replace(/\{(\w+)\}/g, function (m, k) {
      return vars[k] != null ? vars[k] : m;
    });
  }

  function Fmt(locale) {
    var loc = [locale, 'en'];
    this.num = new Intl.NumberFormat(loc);
    this.day = new Intl.DateTimeFormat(loc, { day: 'numeric', month: 'short' });
    this.dayTime = new Intl.DateTimeFormat(loc, { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' });
    this.time = new Intl.DateTimeFormat(loc, { hour: 'numeric', minute: '2-digit' });
    this.rel = window.Intl && Intl.RelativeTimeFormat ? new Intl.RelativeTimeFormat(loc, { numeric: 'auto' }) : null;
  }

  // "Oct 31, 8:00 AM – 2:00 PM" (same day) / "Oct 26 – Nov 1"
  Fmt.prototype.range = function (start, end) {
    var a = new Date(start * 1000);
    var b = new Date(end * 1000);
    if (a.toDateString() === b.toDateString()) return this.dayTime.format(a) + ' – ' + this.time.format(b);
    return this.day.format(a) + ' – ' + this.day.format(b);
  };

  // "in 3 days", "tomorrow", "in 5 hours"
  Fmt.prototype.relative = function (seconds) {
    var abs = Math.abs(seconds);
    var unit = 'minute';
    var value = Math.round(seconds / 60);
    if (abs >= 86400 * 1.5) { unit = 'day'; value = Math.round(seconds / 86400); }
    else if (abs >= 3600) { unit = 'hour'; value = Math.round(seconds / 3600); }
    if (this.rel) return this.rel.format(value, unit);
    return 'in ' + value + ' ' + unit + (value === 1 ? '' : 's');
  };

  /* ---------- render ---------- */

  function slot(el, name) {
    return el.querySelector('[data-slot="' + name + '"]');
  }

  function text(el, value) {
    el.textContent = value || '';
    el.hidden = !value;
  }

  function ages(d, L) {
    var min = d.min_age > 0 ? d.min_age : null; // the app sends 0 for "no minimum" too
    var max = d.max_age > 0 ? d.max_age : null;
    if (min && max) return min + '–' + max;
    if (max) return fill(L.ageUpTo, { n: max });
    if (min) return fill(L.ageFrom, { n: min });
    return '';
  }

  function card(tpl, ev, now, L, F, wide) {
    var li = tpl.content.firstElementChild.cloneNode(true);
    var live = ev.start <= now;
    li.setAttribute('data-type', ev.type);
    if (wide) li.classList.add('fm-evl__item--live'); // only the first live event is the wide card
    if (ev.color) li.style.setProperty('--fm-ev-color', ev.color);

    var img = slot(li, 'cover');
    if (ev.cover) {
      img.src = ev.cover;
      img.alt = ev.title;
      img.hidden = false;
      // a broken cover leaves the cream background
      img.addEventListener('error', function () { img.hidden = true; });
    }

    var status = slot(li, 'status');
    status.textContent = live ? L.live : fill(L.startsIn, { time: F.relative(ev.start - now) });
    if (live) status.classList.add('is-live');

    if (ev.registered > 0) {
      slot(li, 'players').hidden = false;
      slot(li, 'players-text').textContent = fill(L.players, { n: F.num.format(ev.registered) });
    }

    text(slot(li, 'type'), (L.types || {})[ev.type] || '');
    text(slot(li, 'game'), ev.game && ev.more_games ? fill(L.moreGames, { game: ev.game, n: ev.more_games }) : ev.game);
    slot(li, 'title').textContent = ev.title;
    text(slot(li, 'text'), ev.text);
    slot(li, 'dates').textContent = F.range(ev.start, ev.end) + (live ? ' · ' + fill(L.endsIn, { time: F.relative(ev.end - now) }) : '');

    var r = ev.rewards;

    var rows = [[L.places[0], r.first], [L.places[1], r.second], [L.places[2], r.third], [L.participation, r.participation]];
    var dl = slot(li, 'rewards');
    rows.forEach(function (row) {
      if (row[1] == null) return;
      var wrap = document.createElement('div');
      var dt = document.createElement('dt');
      var dd = document.createElement('dd');
      dt.textContent = row[0];
      dd.textContent = fill(L.points, { n: F.num.format(row[1]) });
      wrap.appendChild(dt);
      wrap.appendChild(dd);
      dl.appendChild(wrap);
    });
    dl.hidden = !dl.children.length;

    var ul = slot(li, 'divisions');
    ev.divisions.forEach(function (d) {
      var item = document.createElement('li');
      var a = ages(d, L);
      item.textContent = d.name + (a ? ' · ' + a : '');
      if (d.text) item.title = d.text;
      ul.appendChild(item);
    });
    ul.hidden = !ul.children.length;

    return li;
  }

  function init(root) {
    var list = root.querySelector('[data-fm-events-list]');
    var tpl = root.querySelector('template[data-fm-event-card]');
    var filters = root.querySelector('[data-fm-events-filters]');
    var L = {};
    try { L = JSON.parse(root.querySelector('[data-fm-events-labels]').textContent); } catch (err) {}
    var F = new Fmt(root.getAttribute('data-locale') || document.documentElement.lang || 'en');
    var feed = new Feed(root.getAttribute('data-url') || 'https://flexyminds-app.web.app/api/public/events');
    var type = '';

    function state(name) {
      root.querySelectorAll('[data-fm-events-state]').forEach(function (p) {
        p.hidden = p.getAttribute('data-fm-events-state') !== name;
      });
    }

    function render() {
      if (!feed.data) return;
      var now = feed.now();
      var events = feed.data.events
        .filter(function (e) { return e.end > now; })
        .sort(function (a, b) {
          var la = a.start <= now ? 0 : 1;
          var lb = b.start <= now ? 0 : 1;
          // live: ending soonest first (that one gets the wide card); upcoming: by start
          return la - lb || (la === 0 ? a.end - b.end : a.start - b.start);
        });

      // only the types that have events get a pill
      var types = {};
      events.forEach(function (e) { types[e.type] = true; });
      var shown = 0;
      filters.querySelectorAll('[data-type]').forEach(function (b) {
        var t = b.getAttribute('data-type');
        b.hidden = t !== '' && !types[t];
        if (t && types[t]) shown++;
      });
      if (type && !types[type]) setType('');
      filters.hidden = shown < 2;

      var visible = events.filter(function (e) { return !type || e.type === type; });
      var frag = document.createDocumentFragment();
      visible.forEach(function (e, i) { frag.appendChild(card(tpl, e, now, L, F, i === 0 && e.start <= now)); });
      list.innerHTML = '';
      list.appendChild(frag);
      state(visible.length ? '' : 'empty');
    }

    function setType(t) {
      type = t;
      filters.querySelectorAll('[data-type]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-type') === t));
      });
    }

    filters.addEventListener('click', function (e) {
      var b = e.target.closest('[data-type]');
      if (!b) return;
      setType(b.getAttribute('data-type'));
      render();
    });

    function load() {
      return feed.fetch().then(render, function (err) {
        console.warn(err);
        if (feed.data) return render(); // keep showing the last copy
        list.innerHTML = '';
        state('error');
      });
    }

    if (feed.cached()) render();
    if (!feed.fresh()) load();

    setInterval(function () {
      if (document.visibilityState !== 'visible') return;
      if (!feed.data || Date.now() - feed.data.fetchedAt > REFRESH) load();
      else render();
    }, TICK);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible' && feed.data && !feed.fresh()) load();
    });
  }

  function boot() {
    document.querySelectorAll('[data-fm-events]').forEach(function (root) {
      if (root.fmEvents) return;
      root.fmEvents = true;
      init(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
